import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Legend,
  Tooltip,
} from 'chart.js';

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement,
  BarElement, ArcElement, Filler, Legend, Tooltip
);

// Chrome defaults matched to the design system
ChartJS.defaults.font.family = "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";
ChartJS.defaults.font.size = 11.5;
ChartJS.defaults.color = '#898781';
ChartJS.defaults.borderColor = '#e1e0d9';
ChartJS.defaults.plugins.legend.labels.boxWidth = 10;
ChartJS.defaults.plugins.legend.labels.boxHeight = 10;
ChartJS.defaults.plugins.legend.labels.usePointStyle = true;
ChartJS.defaults.plugins.tooltip.backgroundColor = 'rgba(11,11,11,0.86)';
ChartJS.defaults.plugins.tooltip.padding = 10;
ChartJS.defaults.plugins.tooltip.cornerRadius = 8;
ChartJS.defaults.plugins.tooltip.titleFont = { weight: '600' };

// Categorical palette — fixed slot order, never cycled
export const SERIES = ['#2a78d6', '#1baf7a', '#eda100', '#008300', '#4a3aa7', '#e34948', '#e87ba4', '#eb6834'];

// Color follows the entity: stable colors per order type across every chart
export const ORDER_TYPE_COLORS = {
  'Pickup': '#2a78d6',
  'Delivery': '#1baf7a',
  'Dine In': '#eda100',
  'Quick Dine In': '#4a3aa7',
  'Quick Dine In - Phone': '#e87ba4',
  'Pickup - Phone': '#eb6834',
};
export const orderTypeColor = (t) => ORDER_TYPE_COLORS[t] || '#898781';

// Sequential blue ramp (light→dark) for heatmap magnitude
export const SEQ = ['#cde2fb', '#b7d3f6', '#9ec5f4', '#86b6ef', '#6da7ec', '#5598e7', '#3987e5', '#2a78d6', '#256abf', '#1c5cab', '#184f95', '#104281', '#0d366b'];

export const seqColor = (value, max) => {
  if (!max || value <= 0) return '#f4f3ef';
  const idx = Math.min(SEQ.length - 1, Math.floor((value / max) * SEQ.length));
  return SEQ[idx];
};

export const moneyTick = (v) => {
  const d = v / 100;
  if (Math.abs(d) >= 1_000_000) return `$${(d / 1_000_000).toFixed(1)}M`;
  if (Math.abs(d) >= 1_000) return `$${(d / 1_000).toFixed(0)}K`;
  return `$${d}`;
};
